const AdvancedSearch = function () {	
	const forms = new forms4i();
	const advancedSearchForm = document.getElementById("advSearchForm");
	const conditionalReqdFields = [].slice.call(document.getElementsByClassName("conditionalReqd"));
	
	const init = function() {
		document.getElementById("btnSearch").addEventListener("click", function(e){
			if (advSearchFormValidation(e)) forms.formValidation(advancedSearchForm, formSuccess, e);
		});
	};
	
	const advSearchFormValidation = (e) => {
 		let countReqd = 0;
 		for(let i = 0; i < conditionalReqdFields.length; i++){
 			let el = conditionalReqdFields[i];
 			if ((el.tagName == "INPUT" && el.value != "") || (el.tagName == "SELECT" && el.value != 0)) countReqd++;
 		}

	 	if (countReqd == 0) {
			forms.ClearValidation();
		 	e.preventDefault(); //  stop form submission if no fields are filled out 
			const formHeading = document.getElementsByClassName("formHeading")[0];
			const list = '<li><span tabindex="0" role="link" class="errorItem">No search field is specified; please fill in at least one search criteria field.</span></li>';
			const panel = '<div id="ErrorBox" class="ErrorMsgPanel" role="alert" aria-atomic="true"><h3 id="ErrorTitle" class="validationHeading">Please correct the following errors and resubmit:</h3><ul id="ErrorMsgBox">##ERRORLINES##</ul></div>';
			formHeading.insertAdjacentHTML('afterend', panel.replace("##ERRORLINES##", list));
           		formHeading.scrollIntoView({behavior: "smooth"});
       		return false;
		} else {
			return true;
		}
	};
	
	const formSuccess = () => { };
	
	return {
		Init: init
	};
};

(function(){
	const loadAdvSearch = new AdvancedSearch();
	loadAdvSearch.Init();
})();